/**
 * Stack module-related modals above `NotificationWithBadgeIcon` (zIndex 9999) and
 * use `ModalContent`’s `containerProps={{ zIndex: content }}` so the dimmed
 * overlay does not sit above the dialog. Same rule as `TagDiffModal` /
 * `ModuleEditorModal`.
 */
export const MODULE_MODAL_OVERLAY_Z_INDEX = 10050;
export const MODULE_MODAL_CONTENT_Z_INDEX = MODULE_MODAL_OVERLAY_Z_INDEX + 1;

/** AlertDialogs nested on top of module modals. */
export const MODULE_MODAL_NESTED_ALERT_Z_INDEX = 10060;
export const MODULE_MODAL_NESTED_ALERT_CONTENT_Z_INDEX =
  MODULE_MODAL_NESTED_ALERT_Z_INDEX + 1;

/** `TagDiffModal` opened on top of `ModuleEditorModal` (e.g. 差分プレビュー). */
export const MODULE_NESTED_TAG_DIFF_OVERLAY_Z_INDEX = 10070;
export const MODULE_NESTED_TAG_DIFF_CONTENT_Z_INDEX =
  MODULE_NESTED_TAG_DIFF_OVERLAY_Z_INDEX + 1;
